import React, {useRef, useEffect, useState} from 'react';

class Audience extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div class="row mb-2">
                <div class="col">
                    <h5 class="mb-1">{this.props.display} <span class="badge bg-secondary">{this.props._additional.distance}</span></h5>
                    <h6 class="mb-1">shortTitle: {this.props.shortTitle}&nbsp; &bull; &nbsp;longTitle: {this.props.longTitle}</h6>
                    <h6 class="secondary-infos"> Key: {this.props.id}&nbsp; &bull; &nbsp;Analyse: {this.props.analysisId}&nbsp; &bull; &nbsp;Pfad: {this.props.path}&nbsp; &bull; &nbsp;Typ: {this.props.type}</h6>
                    <hr/>
                </div>
            </div>
        )
    }
}

export default Audience;
